<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="modal modal-open z-[100]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="fictional-disclaimer-title"
      aria-describedby="fictional-disclaimer-body"
    >
      <div class="modal-box max-w-lg shadow-2xl" @click.stop>
        <div class="flex items-start gap-3">
          <i class="mdi mdi-alert-outline text-3xl text-warning shrink-0 mt-0.5" aria-hidden="true" />
          <div class="min-w-0">
            <h3 id="fictional-disclaimer-title" class="font-bold text-lg leading-tight">
              Fictional data
            </h3>
            <p id="fictional-disclaimer-body" class="text-sm text-base-content/80 mt-3 leading-relaxed">
              Everything you see on Stock Jockey—including tickers, prices, returns, rankings,
              portfolios, and competition details—is <strong class="text-base-content">fictional
              and for demonstration only</strong>. It is not investment advice and does not reflect
              real markets or real outcomes.
            </p>
          </div>
        </div>
        <div class="modal-action mt-6">
          <button type="button" class="btn btn-primary" @click="onUnderstand">
            I understand
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { watch, onUnmounted } from 'vue'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue', 'acknowledge'])

function onUnderstand() {
  emit('acknowledge')
  emit('update:modelValue', false)
}

function blockEscape(e) {
  if (e.key === 'Escape' && props.modelValue) {
    e.preventDefault()
    e.stopPropagation()
  }
}

watch(
  () => props.modelValue,
  (open) => {
    if (open) {
      window.addEventListener('keydown', blockEscape, true)
    } else {
      window.removeEventListener('keydown', blockEscape, true)
    }
  },
  { immediate: true },
)

onUnmounted(() => {
  window.removeEventListener('keydown', blockEscape, true)
})
</script>
